/**
 * @generated SignedSource<<e5c96bd00655a11a9e01f1876b0a5ed0>>
 * @relayHash 7ab61c1725765aeb799d361e612cdf4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 008e272d14279dc9d7e2a5a369c6d649069d8c0dbc4f5a7be0ed8b50858912f3

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GrowthRecContext = {
  anonymousId?: string | null;
  containers?: AGG$JSON | null;
  custom?: AGG$JSON | null;
  locale?: string | null;
  orgId?: string | null;
  product?: string | null;
  rankingOptimization?: string | null;
  sessionId?: string | null;
  subproduct?: string | null;
  tenantId?: string | null;
  useCase?: string | null;
  userId?: string | null;
  workspaceId?: string | null;
};
export type standardToPremiumModalQuery$variables = {
  cloudId: string;
  context?: GrowthRecContext | null;
  hamsProductKey: string;
  shouldCheckPaidToTwc: boolean;
};
export type standardToPremiumModalQuery$data = {
  readonly growthRecommendations?: {
    readonly recommendations: {
      readonly __typename: "GrowthRecRecommendations";
      readonly data: ReadonlyArray<{
        readonly entityId: string;
      }> | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly " $fragmentSpreads": FragmentRefs<"standardToPremiumModalExperienceCapabilitiesFragment">;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type standardToPremiumModalQuery = {
  response: standardToPremiumModalQuery$data;
  variables: standardToPremiumModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hamsProductKey"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldCheckPaidToTwc"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "hamsProductKey"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "context"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v6 = [
  (v4/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isAvailableToUser"
  },
  {
    "kind": "ScalarField",
    "name": "experienceUrl"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "standardToPremiumModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "standardToPremiumModalExperienceCapabilitiesFragment"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckPaidToTwc",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GrowthRecQuery",
            "kind": "LinkedField",
            "name": "growthRecommendations",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "recommendations",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": true,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "GrowthRecRecommendations"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "standardToPremiumModalQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCommerceEntitlementExperienceCapabilities"
                      },
                      {
                        "alias": "changeOfferingV2ToPremium",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "offeringName",
                            "value": "Premium"
                          }
                        ],
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                      },
                      {
                        "alias": "changeOfferingV2PlanSelectionPage",
                        "kind": "LinkedField",
                        "name": "changeOfferingV2",
                        "plural": false,
                        "selections": (v6/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldCheckPaidToTwc",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "GrowthRecQuery",
            "kind": "LinkedField",
            "name": "growthRecommendations",
            "plural": false,
            "selections": [
              {
                "args": (v3/*: any*/),
                "kind": "LinkedField",
                "name": "recommendations",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ],
                    "type": "GrowthRecRecommendations"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "008e272d14279dc9d7e2a5a369c6d649069d8c0dbc4f5a7be0ed8b50858912f3",
    "metadata": {},
    "name": "standardToPremiumModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d382e6056b08a326ab7ede638db4a220";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
